import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { ProcessoArquivo } from '@app/models/processo-arquivo.model';
import { ProcessoService } from '@app/services/processo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

@Component({
  selector: 'app-arquivos',
  templateUrl: './arquivos.component.html',
  styleUrls: ['./arquivos.component.scss']
})
export class ArquivosComponent implements OnInit {

  processoId: number;
  lstProcessoArquivo: Array<ProcessoArquivo> = [];
  bsModalRef: BsModalRef;

  processoArquivado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private processoService: ProcessoService
  ) { }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obterMovimentacao();
      });
  }

  solicitarPasta() {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente solicitar a pasta?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.solicitarArquivo(this.processoId)
        .toPromise()
        .then(
          () => this.obterMovimentacao(),
          (errorResponse) => {
            const errorMessage = errorResponse.error.errors[0];
            this.toastr.error(errorMessage);
          }
        );
    };
  }

  obterMovimentacao() {
    this.processoService.obterArquivosPorProcesso(this.processoId).toPromise().then((data) => this.lstProcessoArquivo = data);
  }

  entregarPastar(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente entregar a pasta?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.encaminharPasta(id).toPromise().then((data) => {
        this.toastr.success('Pasta entregue com sucesso');
        this.obterMovimentacao();
      },
        (erro) => this.toastr.error(erro.errors));
    };
  }

  devolverPasta(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente devolver a pasta?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.devolverPasta(id).toPromise().then((data) => {
        this.toastr.success('Pasta devolvida com sucesso');
        this.obterMovimentacao();
      },
        (erro) => this.toastr.error(erro.errors));
    };
  }

  cancelar(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente cancelar a solicitação?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.cancelarArquivo(id).toPromise().then((data) => {
        this.toastr.success('Cancelado com sucesso');
        this.obterMovimentacao();
      },
        (erro) => this.toastr.error(erro.errors));
    };
  }
}
